import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="guarantee-title" className="bg-brand-sand px-4 py-20" data-id="element-121" data-mp="4w1hevzztakf">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-122" data-mp="9tbcosa2cgg6">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-123" data-mp="etfvioyg1n9k">
          <FileTextIcon className="h-8 w-8 text-brand-teal" aria-hidden="true" data-id="element-124" data-mp="jsslhikm3agd" />
        </div>
        <h2 id="guarantee-title" className="text-2xl font-extrabold tracking-tight text-brand-navy md:text-3xl" data-id="element-125" data-mp="ntvxftzjgmcb">
          Une collection numérique, en toute clarté.
        </h2>
        <p className="mx-auto mt-6 max-w-xl leading-relaxed text-slate-600" data-id="element-126" data-mp="sn6vp6qabusm">
          Vous recevez des <strong className="font-bold text-slate-800" data-id="element-127" data-mp="xm1qz85fvbtm">fichiers PDF</strong> à consulter, imprimer ou
          projeter. Les livres, instruments et appareils du visuel illustrent les usages et{' '}
          <strong className="font-bold text-slate-800" data-id="element-128" data-mp="17g0k5hnjbl9f">ne sont pas livrés</strong>.
        </p>
      </Reveal>
    </section>;
}